import createTheme from '@mui/material/styles/createTheme';
import StryderDesign from './StryderDesign';

/**
 * Hook(s) for loading themes via the theme (design) service.
 */
const useThemes = () => {
  const asset = StryderDesign.assets;
  const muiTheme = createTheme(asset.muiThemes);
  const skinTheme = asset.skinThemes;

  return {
    muiTheme,
    skinTheme
  };
};

export default useThemes;
